import React from 'react';
import AUX from '../../../../hoc/Aux_';
import {
  FaCode,
  FaChrome,
  FaFolderOpen,
  FaClock,
  FaCalendarAlt,
  FaHistory,
  FaWordpress,
  FaSlack,
  FaFileExcel,
  FaWindows,
  FaTerminal,
} from 'react-icons/fa';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import moment from 'moment';

const AppsUsages = ({ open, onClose, ID, filterBy }) => {
  const appUsages = ID?.appWebsiteDetailsUsage || [];
  const totalDuration = appUsages.reduce(
    (total, app) => total + app.duration,
    0
  );

  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return 'N/A';
    if (seconds < 60) {
      return `${seconds} s`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} m`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    } else {
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
    }
  };

  const getAppIcon = (appName) => {
    if (!appName) return <FaClock size={24} />;
    const name = appName.toLowerCase();

    if (name.includes('code') || name.includes('visual studio'))
      return <FaCode size={24} />;
    if (
      name.includes('chrome') ||
      name.includes('browser') ||
      name.includes('firefox') ||
      name.includes('safari')
    )
      return <FaChrome size={24} />;
    if (name.includes('explorer') || name.includes('folder'))
      return <FaFolderOpen size={24} />;
    if (name.includes('excel') || name.includes('spreadsheet'))
      return <FaFileExcel size={24} />;
    if (name.includes('slack')) return <FaSlack size={24} />;
    if (name.includes('wordpress')) return <FaWordpress size={24} />;
    if (
      name.includes('terminal') ||
      name.includes('cmd') ||
      name.includes('powershell')
    )
      return <FaTerminal size={24} />;
    if (name.includes('windows')) return <FaWindows size={24} />;

    return <FaClock size={24} />;
  };

  const getAppColor = (appName) => {
    if (!appName) return '#6c757d';
    const name = appName.toLowerCase();

    if (name.includes('code') || name.includes('visual studio'))
      return '#0078d7';
    if (name.includes('chrome') || name.includes('browser')) return '#4285F4';
    if (name.includes('explorer') || name.includes('folder')) return '#FFBA08';
    if (name.includes('excel') || name.includes('spreadsheet'))
      return '#217346';
    if (name.includes('slack')) return '#4A154B';
    if (name.includes('wordpress')) return '#21759b';
    if (
      name.includes('terminal') ||
      name.includes('cmd') ||
      name.includes('powershell')
    )
      return '#333333';
    if (name.includes('windows')) return '#0078D6';

    return '#6c757d';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return moment(dateString).format('MMM D, YYYY h:mm A');
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div
            className={`overlay ${open ? 'open' : ''} overflow-hidden`}
            id="myNav"
            style={{
              width: open ? '50%' : '',
            }}
          >
            <div className="overlay-content py-0" style={{ padding: '20px' }}>
              <div
                className="slide_Headr pb-3 pt-2  border-bottom mb-4"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <h6 className="m-0">App Usage</h6>
                <i
                  className="mdi mdi-close"
                  onClick={onClose}
                  style={{ fontSize: '22px', cursor: 'pointer' }}
                />
              </div>

              <div className="websites_container px-3 pt-0">
                <div className="details_container mb-4">
                  <div className="details_tab mb-2">
                    <span>
                      <b>Project Name</b> :{' '}
                      {ID?.projectTask?.project?.name || 'N/A'}
                    </span>
                  </div>
                  <div className="details_tab mb-2">
                    <span>
                      <b>Task</b> : {ID?.projectTask?.name || 'N/A'}
                    </span>
                  </div>
                  <div className="details_tab">
                    <span>
                      <b>Description</b> :{' '}
                      {filterBy === 'MINUTE' &&
                      ID?.projectTaskActivity?.description
                        ? ID?.projectTaskActivity?.description
                        : ID?.description || 'N/A'}
                    </span>
                  </div>
                </div>

                {/* Summary Card */}
                <div className="card mb-4">
                  <div className="card-body">
                    <h6 className="card-title border-bottom pb-2">Summary</h6>
                    <div className="row text-center">
                      <div className="col-md-4 mb-3">
                        <h4>{appUsages.length}</h4>
                        <p className="text-muted">Apps Used</p>
                      </div>
                      <div className="col-md-4 mb-3">
                        <h4>{formatDuration(totalDuration)}</h4>
                        <p className="text-muted">Total Duration</p>
                      </div>
                      <div className="col-md-4 mb-3">
                        <h4>
                          {appUsages.reduce(
                            (total, app) => total + app.sessions,
                            0
                          )}
                        </h4>
                        <p className="text-muted">Total Sessions</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* App Usage Cards */}
                <h6 className="mb-3">App Usage Details</h6>
                <div className="row">
                  {appUsages.map((app, index) => (
                    <div className="col-lg-6 col-md-6 mb-4" key={index}>
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="d-flex align-items-center mb-3">
                            <div
                              style={{
                                backgroundColor: getAppColor(app.name),
                                color: '#fff',
                                padding: '8px',
                                borderRadius: '6px',
                                marginRight: '10px',
                              }}
                            >
                              {getAppIcon(app.name)}
                            </div>
                            <h6 className="mb-0">{app.name}</h6>
                          </div>

                          <div className="row mb-3">
                            <div className="col-8">
                              <div className="small text-muted mb-1">
                                <FaClock
                                  className="mr-1"
                                  style={{ marginRight: '4px' }}
                                />{' '}
                                Duration
                              </div>
                              <p className="mb-2">
                                <strong>{formatDuration(app.duration)}</strong>
                              </p>

                              <div className="small text-muted mb-1">
                                <FaHistory
                                  className="mr-1"
                                  style={{ marginRight: '4px' }}
                                />{' '}
                                Sessions
                              </div>
                              <p className="mb-0">
                                <strong>{app.sessions}</strong>
                              </p>
                            </div>
                            <div className="col-4 text-center">
                              <div
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  margin: '0 auto',
                                }}
                              >
                                <CircularProgressbar
                                  value={(app.duration / totalDuration) * 100}
                                  text={`${Math.round((app.duration / totalDuration) * 100)}%`}
                                  styles={buildStyles({
                                    textSize: '24px',
                                    pathColor: getAppColor(app.name),
                                    textColor: getAppColor(app.name),
                                    trailColor: '#eee',
                                  })}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="small">
                            <div className="text-muted mb-1">
                              <FaCalendarAlt style={{ marginRight: '4px' }} />{' '}
                              First Used:
                            </div>
                            <p className="mb-2">{formatDate(app.firstUsed)}</p>

                            <div className="text-muted mb-1">
                              <FaCalendarAlt style={{ marginRight: '4px' }} />{' '}
                              Last Used:
                            </div>
                            <p className="mb-0">{formatDate(app.lastUsed)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default AppsUsages;
